module.exports = __webpack_public_path__ + "img/tutorial_course_04.00c6665a.gif";